import React, { useEffect, useState } from "react";
import { makeStyles } from '@mui/styles';
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import { FormControl, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import modalHandler from "../../utils/modalHandler";
import axios from "../../utils/axiosConfig";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    '& .MuiBackdrop-root': {
      backgroundColor: 'rgba(0, 0, 0, 0.5)'
    }
  },
  paper: {
    backgroundColor: "#ffffff",
    padding: theme.spacing(2, 4, 3),
    borderRadius: "15px",
    width: "380px",
    position: 'relative',
    outline: 'none',
    boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12)'
  }
}));

export default function LanguageModal(Props) {
  const classes = useStyles();
  let _reload = true;
  const { showLanguageModal, setShowLanguageModal, modalHandlerData } = Props
  const {
    row, index,name,userExamId,props,setLoading,setModelShow,setMsgModal,setResumeLoader,setMessageModal,setMessage,setCodeLanguages
  } = modalHandlerData;
  const [languages, setLanguages] = useState([])
  const [selectedLanguage, setSelectedLanguage] = useState()
  const [showLanguageRequiredMessage, setShowLanguageRequiredMessage] = useState(false)
  const [showConfirmationMessage, setShowConfirmationMessage] = useState(false)

  window.onbeforeunload = function () {
    return null; // return null to avoid pop up
  };

  useEffect(()=>{
    try {
      axios.get('/dashboard/getLanguages',{  
          headers: {
            'Access-Control-Allow-Origin': '*',
            userexamid: userExamId,
          }
      }).then(result =>{
          // console.log(result.data)
          setLanguages(result.data.languagesData)
          if (result.data.languagesData && result.data.languagesData.length > 0 && result.data.preferredLanguage && row.languageLocale) {
            if (row.languageLocale.split(",").includes(result.data.preferredLanguage) && result.data.languagesData.find(item => item.locale === result.data.preferredLanguage) !== undefined) {
              setSelectedLanguage(result.data.preferredLanguage)
            }
          }
      }).catch(error => {
        console.log(error) 
      })
    } catch (error) {
      console.log(error)
    }   
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div>
      <Modal
        disableEnforceFocus={true}
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={showLanguageModal}
        
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={showLanguageModal}>
          <div className={classes.paper} style={{ textAlign: "justify" }}>
            <div style={{ textAlign: "center" }}>
              <h3 id="transition-modal-title" style={{ color: "#6f2981", marginBottom: "30px" }}>
                Select Test Language
              </h3>
            </div>
            <div>
                <div className="form-group">
                    <FormControl style={{ width: "-webkit-fill-available" }}>
                        <InputLabel id="demo-simple-select-helper-label">Test Language</InputLabel>
                        <Select
                            labelId="demo-simple-select-helper-label"
                            id="demo-simple-select-helper"
                            label="language"
                            onChange={(e) => { setShowLanguageRequiredMessage(false); setSelectedLanguage(e.target.value) }}
                            name='lang-select'
                            value={selectedLanguage || ""}
                        >
                        {languages && Array.isArray(languages) && languages.length !== 0 && 
                          languages.filter(item => row.languageLocale.split(",").includes(item.locale)).map((item, index) => {
                            return <MenuItem key={index} value={item.locale}>{item.language}</MenuItem>
                        })}
                        </Select>
                    </FormControl>
                    {showLanguageRequiredMessage ?
                      <Typography style={{ color: "red", marginTop: "10px", paddingBottom: 0 }}>Test Language Required !!</Typography>
                      : 
                      <></>
                    }
                    {showConfirmationMessage ?
                      <Typography style={{ marginTop: "20px", paddingBottom: 0, textAlign: "center" }}>Test Language cannot be changed after the test has started. Are you sure you want to continue with this language?</Typography>
                      : 
                      <></>
                    }
                    <div style={{ textAlign: "center", marginTop: "20px" }}>
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a href="#" className="btn btn-blue" style={{ borderRadius: "10px" }} onClick={() => setShowLanguageModal(false)}>
                        <strong>GO BACK</strong>
                      </a>
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a href="#" className="btn btn-blue" style={{ borderRadius: "10px", marginLeft: "15px" }} onClick={selectedLanguage ? showConfirmationMessage ? () => { setShowLanguageModal(false); modalHandler(row, index,name,props,setLoading,setModelShow,setMsgModal,setResumeLoader,setMessageModal,setMessage,setCodeLanguages,selectedLanguage); } : () => setShowConfirmationMessage(true) : () => { setShowLanguageRequiredMessage(true) }}>
                        <strong>PROCEED</strong>
                      </a>
                      
                    </div>
                </div>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}